/* Code generated with AutoHTML Plugin for Figma */
import { Article } from "@project/shared-types";
import { BreadCrumbs } from "../../components/BreadCrumbs/BreadCrumbs";
import EditorBlocks from "../../components/EditorBlocks/EditorBlocks";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _colorText, _sizeHeading, _sizeText } from "../../core/core";
import { BlockBase } from "../BlockBase/BlockBase";
import "./Info.css";

import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { GetArticleAPI } from "../../api/BlogAPI";
import { Loader } from "../../components/Loader/Loader";

export const Info = ({ ...props }) => {
  const [article, setArticle] = useState<Article | null>(null);
  const currentPage = useLocation();
  const breadLinks = useMemo(() => {
    return [
      { url: "/", name: "Главная" },
      { url: "/blog/", name: "Блог" },
      { url: currentPage.pathname, name: article?.title || "Загрузка..." },
    ];
  }, [article]);

  const fetchArticles = async () => {
    try {
      const response = await GetArticleAPI({
        article_url: currentPage.pathname.replace("/blog/", ""),
      });
      if (response.article) {
        setArticle(response.article);
      }
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };
  const scrollToHash = () => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          let elementId = hash.substring(1); // Убираем #
          elementId = elementId.replace(/\/$/, ""); // Убираем конечный слэш, если он есть
          const element = document.querySelector(`[data-id='${elementId}']`);
          console.log(element);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 1000);
      }
    }
  };
  useEffect(() => {
    fetchArticles();
    // Скроллим при монтировании компонента
    scrollToHash();
    if (typeof window !== "undefined") {
      // Добавляем слушатель событий для изменения хэша
      window.addEventListener("hashchange", scrollToHash);
    }

    // Убираем слушатель при размонтировании компонента
    return () => {
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);
  if (!article) {
    return <Loader isLoading={true} />;
  }
  return (
    <>
      <title>{article.title}</title>
      <meta name="description" content={article.description} />
      <BreadCrumbs links={breadLinks}></BreadCrumbs>
      <BlockBase>
        <div className="info-header">
          <Title type={_sizeHeading.h2} is_h1>
            {article.title}
          </Title>
        </div>

        <div className="info-body">
          <EditorBlocks article={article}></EditorBlocks>
        </div>

        <div className="info-footer">
          <Text size={_sizeText.m} color={_colorText.neutral}>
            Дата обновления:{" "}
            {new Date(article.date_published).toLocaleDateString()}
          </Text>
        </div>
        <time
          className="flex items-center"
          dateTime={new Date(article.date_published).toISOString()}
        ></time>
        <meta
          itemProp="datePublished"
          content={new Date(article.date_published).toISOString()}
        ></meta>
      </BlockBase>
    </>
  );
};
